export default "__VITE_ASSET__DQ3I2my7__"